import React from 'react';
export const ChatTestimonials = () => {
  const testimonials = [{
    initial: 'L',
    name: 'Liset',
    time: '21:29',
    text: 'Super bedankt. Was boeiend en leerzaam.',
    color: 'bg-purple-500'
  }, {
    initial: 'L',
    name: 'Linda',
    time: '21:39',
    text: 'leuk filmpje :-) Zie mezelf en mijn "hondenkleinkids" :))) aangenaam verast. Dankjewel voor de masterclass',
    color: 'bg-blue-500'
  }, {
    initial: 'K',
    name: 'Karin',
    time: '21:40',
    text: 'Heel erg bedankt, het was heel leerzaam',
    color: 'bg-green-500'
  }, {
    initial: 'A',
    name: 'Annemieke',
    time: '21:40',
    text: 'heel erg bedankt voor de masterclass! groetjes, Annemieke',
    color: 'bg-pink-500'
  }, {
    initial: 'C',
    name: 'Corrie',
    time: '21:40',
    text: 'Bedankt voor je heldere uitleg! Fijne avond',
    color: 'bg-orange-500'
  }];
  const emailTestimonial = {
    from: 'Jessica',
    to: 'mij',
    subject: 'Hi Amee,',
    text: 'Super, het is gelukt. Dankjewel!\n\nIk wilde nog mijn complimenten geven voor de masterclass van gisteren. Ik heb menig gratis webinars gevolgd en vond die van jou echt wel de beste. Ben benieuwd naar de cursussen!\n\nGroeten, Jessica'
  };
  return <section className="mb-12" data-id="element-166" data-mp="6r3y83mi6wwa">
      <h2 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-167" data-mp="6rdfn2thfvqd">
        Meer reacties van deelnemers
      </h2>

      <div className="space-y-3 mb-6" data-id="element-168" data-mp="br9howimdd3a">
        {testimonials.map((testimonial, index) => <div key={index} className="bg-gray-50 border border-gray-200 rounded-lg p-4" data-id="element-169" data-mp="gqcoomi5ttdw" data-mpi={index}>
            <div className="flex items-start" data-id="element-170" data-mp="poy0zzx1gc68">
              <div className={`w-8 h-8 ${testimonial.color} text-white rounded-full flex items-center justify-center font-bold mr-3 flex-shrink-0 text-sm`} data-id="element-171" data-mp="pnn2ofmd3wmi">
                {testimonial.initial}
              </div>
              <div className="flex-1" data-id="element-172" data-mp="3ur760xzgju66">
                <div className="flex items-center justify-between mb-1" data-id="element-173" data-mp="3us9tsx1hhghv">
                  <span className="font-semibold text-gray-900 text-sm" data-id="element-174" data-mp="3psdtb7rzw772">
                    {testimonial.name}
                  </span>
                  <span className="text-xs text-gray-500" data-id="element-175" data-mp="7nah733m2ux5">
                    {testimonial.time}
                  </span>
                </div>
                <p className="text-gray-700 text-sm" data-id="element-176" data-mp="hkoyt619tpr1">{testimonial.text}</p>
              </div>
            </div>
          </div>)}
      </div>

      <div className="bg-white border border-gray-300 rounded-lg p-5" data-id="element-177" data-mp="ckssv190jo8u">
        <div className="border-b border-gray-200 pb-3 mb-3" data-id="element-178" data-mp="rb00elxhfmur">
          <p className="text-sm text-gray-600" data-id="element-179" data-mp="rcku69bz31rk">
            <span className="font-semibold" data-id="element-180" data-mp="mb5bgnx9p7cc">{emailTestimonial.from}</span> aan{' '}
            {emailTestimonial.to}
          </p>
        </div>
        <p className="font-semibold text-gray-900 mb-3" data-id="element-181" data-mp="1093nhmo48roo">
          {emailTestimonial.subject}
        </p>
        <p className="text-gray-700 leading-relaxed whitespace-pre-line text-sm" data-id="element-182" data-mp="va0ke7rp4vjc">
          {emailTestimonial.text}
        </p>
      </div>
    </section>;
};